import React from 'react';
import moment from 'moment';
import {Button, Modal} from 'semantic-ui-react';
import {
  TASK_TABLE_COLUMNS,
  TASK_TABLE_HEADER,
  PARTS_TABLE_HEADER,
  PARTS_TABLE_COLUMNS,
  COMMENTS_TABLE_COLUMNS,
  COMMENTS_TABLE_HEADER,
  SUBTASK_TABLE_HEADER,
  SUBTASK_TABLE_COLUMNS,
} from './constants';
import {getStatus, getTypeOrder} from '../utils';
import {fullDateShow} from '../../../../common/constants/datesFormat';
import Description from './Description';
import TableKanban from './Table';
import './styles.scss';

const getTotal = (arr = [], field, fixed = 2) =>
  parseFloat(arr.reduce((acc, value) => acc + value[field], 0)).toFixed(fixed);

const DetailKanban = ({showModal, open, selectOrder, detail, loadingDetail}) => {
  const {orderId} = selectOrder;
  const {orderInfo, tasks, parts, comments, subtasks} = detail;

  const parseTotals = parts.map((part) => ({
    ...part,
    'cost': `$ ${part.cost}`,
    'total': `$ ${part.total}`,
  }));

  const partsTotals = [
    '',
    'TOTAL',
    `${getTotal(parts, 'quantity', 0)}`,
    `$ ${getTotal(parts, 'price')}`,
    `$ ${getTotal(parts, 'total')}`,
  ];

  const parseComments = comments.map((comment) =>
    ({...comment, 'type': getTypeOrder(comment.orderType),
      'date': moment(new Date(comment.receptionDate)).format(fullDateShow)}));

  const parseSubtasks = subtasks.map((task) =>
    ({...task,
      'requestDate': moment(new Date(task.requestDate)).format(fullDateShow),
      'deliveryDate': moment(new Date(task.deliveryDate)).format(fullDateShow),
      'price': task.price ? `$${task.price}` : '$0',
    }));

  return (
    <Modal
      className='modal-kanban'
      size="fullscreen"
      onClose={() => showModal(false)}
      open={open}
      trigger={<Button>Show Modal</Button>}
    >
      <Modal.Header className="table-kanban-logistic-header" >
        <h1>Orden de trabajo No. {orderId} - {!loadingDetail && getStatus(orderInfo.statusId).toUpperCase()} </h1>
      </Modal.Header>
      <Modal.Content scrolling>
        {loadingDetail ?
          <h3>Cargando ...</h3> :
          <div>
            <Description description={orderInfo} width={30} />
            <TableKanban
              title="Trabajos"
              header={TASK_TABLE_HEADER}
              columns={TASK_TABLE_COLUMNS}
              data={tasks}
              leftSide={[2, 3]}
              widthColumn={[1]}
            />
            <TableKanban
              title="Subcontratos"
              header={SUBTASK_TABLE_HEADER}
              columns={SUBTASK_TABLE_COLUMNS}
              data={parseSubtasks}
              leftSide={[2, 4, 5, 6]}
            />
            <TableKanban title="Partes"
              header={PARTS_TABLE_HEADER}
              columns={PARTS_TABLE_COLUMNS}
              data={parseTotals}
              totals={partsTotals}
              leftSide={[2, 3, 4]}
              widthColumn={[1]}
            />
            <TableKanban title="Observación de otras ordenes"
              header={COMMENTS_TABLE_HEADER}
              columns={COMMENTS_TABLE_COLUMNS}
              data={parseComments}
              widthColumn={[2]}
            />
          </div>}
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={() => showModal(false)}>Cerrar</Button>
      </Modal.Actions>
    </Modal>
  );
};

export default DetailKanban;
